import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref } from "vue";
import { useIsMobile } from "@/utils/reactive";
import GroupInvitationUI from "@/components/groups/GroupInvitationUI.vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    groupId: null,
    label: {
      default: "Manage invitation links"
    },
    title: {
      default: "Invitation links"
    }
  },
  emits: ["open", "closed", "fetched", "created", "removed"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var isMobile = useIsMobile();
    var show = ref(false);
    return function (_ctx, _cache) {
      var _component_n_button = _resolveComponent("n-button");

      var _component_n_modal = _resolveComponent("n-modal");

      return _openBlock(), _createElementBlock(_Fragment, null, [_renderSlot(_ctx.$slots, "action", {
        trigger: function trigger() {
          return show.value = true;
        },
        label: __props.label
      }, function () {
        return [_createVNode(_component_n_button, {
          type: "info",
          onClick: _cache[0] || (_cache[0] = function ($event) {
            return show.value = true;
          })
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(__props.label), 1)];
          }),
          _: 1
        })];
      }), _createVNode(_component_n_modal, {
        show: show.value,
        "onUpdate:show": _cache[4] || (_cache[4] = function ($event) {
          return show.value = $event;
        }),
        "auto-focus": !_unref(isMobile),
        title: __props.title,
        preset: "card",
        class: "large",
        onAfterEnter: _cache[5] || (_cache[5] = function ($event) {
          return emit('open');
        }),
        onAfterLeave: _cache[6] || (_cache[6] = function ($event) {
          return emit('closed');
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(GroupInvitationUI, {
            groupId: __props.groupId,
            onFetched: _cache[1] || (_cache[1] = function (links) {
              return emit('fetched', links);
            }),
            onCreated: _cache[2] || (_cache[2] = function (link) {
              return emit('created', link);
            }),
            onRemoved: _cache[3] || (_cache[3] = function (link) {
              return emit('removed', link);
            })
          }, null, 8, ["groupId"])];
        }),
        _: 1
      }, 8, ["show", "auto-focus", "title"])], 64);
    };
  }
});